import {useEffect} from 'react'
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";

const Redirect = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.authRedux);

    useEffect(() => {
        //Redirects to the new view if it is a company with bussinesscode 2 (agent) or area manager.
        if(user.roles.find(v => v.id === 5) || user.roles.find(v => v.id === 8)){
          navigate(`/admin/client/dashboard/detail/user/${id}/${user.id}`)
          
        } 
    
        if(user.roles.find(v => v.id === 6) || user.roles.find(v => v.id === 7)){
          navigate(`/admin/client/dashboard/detail/${id}/${user.companyId}`)
        } 
      }, [])

    return <div className='d-flex h-50 justify-content-center align-items-center'><Spin /></div>
}

export default Redirect;